import './AccidentStatistic.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useRef } from "react";

import { fetchAccidents } from "../../slices/statisticSlice";

import { Box } from "@mui/material";

import ReactECharts from 'echarts-for-react';

const AccidentStatistic = ({params}) => {
    const dispatch = useDispatch();
    const accidentStatistic = useSelector((state) => state.statistic.accidentStatistic);
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const chartRef = useRef(null);

    useEffect(() => {
        dispatch(fetchAccidents({token, params}));
    }, [dispatch, token, params]);

    useEffect(() => {
        setTimeout(() => {
            chartRef.current?.getEchartsInstance().resize();
        }, 100);
    }, [accidentStatistic]);

    const options = {
        title: {
            text: 'График аварийных ситуаций',
            left: 'center',
            top: '5%'
        },
        tooltip: {
            trigger: 'item'
        },
        series: [
            {
                name: 'Аварийная ситуация',
                type: 'pie',
                radius: '50%',
                data: accidentStatistic.map((item) => ({
                    name: item.name,
                    value: item.count
                })),
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };

    return (
        <Box className="accident_statistic">
            <ReactECharts ref={chartRef} option={options} style={{ width: '100%', height: '100%' }} />
        </Box>
    );
};

export default AccidentStatistic;